$(document).ready(function () {
  // ========================
  // Navigation Accessibility
  // ========================

  var $menuTriggers = $('.header__nav .header-menu-trigger');

  // Toggle submenu on click
  $menuTriggers.on('click', function (e) {
    e.preventDefault();
    var $button = $(this);
    var $parentLi = $button.parent('li');
    var isExpanded = $button.attr('aria-expanded') === 'true';

    // Close sibling menus at the same level
    $parentLi.siblings('.have-submenu').find('.header-menu-trigger').attr('aria-expanded', 'false');
    $parentLi.siblings('.have-submenu').removeClass('is-open');

    // Toggle this menu
    $button.attr('aria-expanded', !isExpanded);
    $parentLi.toggleClass('is-open', !isExpanded);
  });

  // Close submenu on Escape and return focus to trigger
  $(document).on('keydown', function (e) {
    if (e.key !== 'Escape') return;

    var $focused = $(':focus');
    var $openMenu = $focused.closest('.have-submenu.is-open');

    if ($openMenu.length) {
      var $trigger = $openMenu.children('.header-menu-trigger');
      $trigger.attr('aria-expanded', 'false');
      $openMenu.removeClass('is-open');
      // Defer focus to the next tick so NVDA reads the updated aria-expanded="false"
      // rather than the stale "true" value from the same synchronous frame.
      setTimeout(function () { $trigger.focus(); }, 0);
      e.stopPropagation();
    }
  });

  // Arrow key navigation within open submenus
  $(document).on('keydown', '.header__submenu, .header-mega-menu', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

    e.preventDefault();
    var $focusable = $(this).find('a, button').filter(':visible');
    var index = $focusable.index(document.activeElement);

    if (e.key === 'ArrowDown') {
      index = (index + 1) % $focusable.length;
    } else {
      index = (index - 1 + $focusable.length) % $focusable.length;
    }

    $focusable.eq(index).focus();
  });

  // Close individual submenu when focus leaves it
  $('.header__nav').on('focusout', '.have-submenu', function () {
    var $menuItem = $(this);

    setTimeout(function () {
      if (!$menuItem.has(document.activeElement).length && !$menuItem.is(document.activeElement)) {
        $menuItem.children('.header-menu-trigger').attr('aria-expanded', 'false');
        $menuItem.removeClass('is-open');
      }
    }, 0);
  });

  // Close menus when clicking outside the nav
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.header__nav').length) {
      $('.header__nav .header-menu-trigger').attr('aria-expanded', 'false');
      $('.header__nav .have-submenu').removeClass('is-open');
    }
  });
});
